/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  GET_TICKETS_FAILURE,
  GET_TICKETS_REQUEST,
  GET_TICKETS_SUCCESS,
  GET_TICKET_HISTORIES_FAILURE,
  GET_TICKET_HISTORIES_REQUEST,
  GET_TICKET_HISTORIES_SUCCESS,
  UPDATE_TICKET_FAILURE,
  UPDATE_TICKET_REQUEST,
  UPDATE_TICKET_SUCCESS
} from "src/actions/ticketActions";

const initialState = {
  tickets: [],
  ticketHistories: [],
  total: 0,
  loading: false,
  loadingHistories: false
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET ticket list case
    case GET_TICKETS_REQUEST: {
      return produce(state, (draft) => {
        draft.tickets = [];
        draft.loading = true;
      });
    }

    case GET_TICKETS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.tickets = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case GET_TICKETS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // GET ticket history list case
    case GET_TICKET_HISTORIES_REQUEST: {
      return produce(state, (draft) => {
        draft.ticketHistories = [];
        draft.loadingHistories = true;
      });
    }

    case GET_TICKET_HISTORIES_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.ticketHistories = response;
        draft.loadingHistories = false;
      });
    }

    case GET_TICKET_HISTORIES_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingHistories = false;
      });
    }

    // UPDATE case
    case UPDATE_TICKET_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_TICKET_SUCCESS: {
      const {response} = action.payload;
      const updateObj = state.tickets.map((item) => {
        if (item.id === response.id) return response;
        return item;
      });

      if (updateObj !== undefined && updateObj.length > 0) {
        return produce(state, (draft) => {
          draft.tickets = updateObj;
          draft.loading = false;
        });
      }

      return produce(state, (draft) => {
        draft.tickets = [];
        draft.loading = false;
      });
    }

    case UPDATE_TICKET_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default ticketReducer;
